import React from 'react'
import Slider from 'react-fast-marquee';
import { FaCss3, FaFigma, FaHtml5, FaJs, FaPhp, FaPython, FaReact } from 'react-icons/fa';
import { FaGit } from 'react-icons/fa6';
import "./marquee.css"


const Marquee = () => {
  return (
    <div className='parentMaxWidth'>
    <Slider className="marquee" autofill ={true} pauseOnHover={false} direction='right'gradient ={true} gradientColor='var(--black)' speed ={30}>
      <FaReact size={55} color='white'></FaReact>
      <FaJs size={55} color='white'></FaJs>
      <FaCss3 size={55} color='white'></FaCss3>
      <FaHtml5 size={55} color='white'></FaHtml5>
      <FaPhp size={55} color='white'></FaPhp>
      <FaPython size={55} color='white'></FaPython>
      <FaFigma size={55} color='white'></FaFigma>
      <FaGit size={55} color='white'></FaGit>
    </Slider>
    </div>
  )
}

export default Marquee